<div class="container mt-5">
    <div class="card card-primary">

        <!-- /.card-header -->
        <!-- form start -->

        <form id="quickForm">
            <div class="card-body">
                <div class="row">
                    <div class="col-lg-3 mt-3" *ngIf="countryLoader==true">
                        <app-small-loader>

                        </app-small-loader>
                    </div>
                    <div class="col-lg-3"  *ngIf="countryLoader==false">
                        <b>Country</b>
                        <datalist id="suggestions1">
                            <option  *ngFor="let item of countriesOption" value="{{item.value}}">{{item.label}}</option>
                          </datalist>
                          <input class="form-control form-control-lg" 
                          autoComplete="on" list="suggestions1" #country (input)="GetProviders(country.value)"/>
                          
                        <!-- <select class="form-control" (change)="GetProviders($event.target)">
                            <option selected disabled>Select Country</option>
                            <option *ngFor="let item of countriesOption" value="{{item.value}}">{{item.label}}</option>
                        </select> -->
                    </div>
                    <div class="col-lg-3 mt-4" *ngIf="providerLoader==true">
                        <app-small-loader>

                        </app-small-loader>
                    </div>
                    <div class="col-lg-3" *ngIf="providerLoader==false">
                        <b>Provider</b>
                        <datalist id="suggestions">
                            <option  *ngFor="let item of providersOption" value="{{item.value}}">{{item.label}}</option>
                          </datalist>
                          <input class="form-control form-control-lg" 
                          autoComplete="on" list="suggestions" #provider (input)="GetProducts(provider.value)"/>
                          

                        <!-- <select class="form-control" (change)="GetProducts($event.target)">
                            <option selected disabled>Select Provider</option>

                            <option *ngFor="let item of providersOption" text="{{item.label}}" value="{{item.value}}">{{item.label}}</option>
                        </select> -->
                    </div>
                    
                    <div class="col-lg-3">
                       <b> Add discount to all</b>
                        <input type="number" (blur)="allValuesDiscount(allDiscounts.value)" #allDiscounts class="form-control">
                    </div>
                    <div class="col-lg-3 mt-4">
                    </div>
                </div>
                <div class="row mt-4" *ngIf="productLoader==true">
                        <app-loader></app-loader>
                </div>
                <app-loader *ngIf="loader"></app-loader>
                <div class="row mt-4 scroll" *ngIf="productLoader==false">
                    <table id="example2" class="table table-bordered table-hover">
                        <thead>
                            <tr>
                                <th> <input type="checkbox" #checkAllProducts (change)="toggleAllRows($event)"></th>
                                <th>Logo</th>
                                <th>Name</th>
                                <th>Amount</th>
                                <th>Commission (In %)</th>
                                <th>Commisssion Reatiler</th>
                            </tr>
                        </thead>
                        <tbody >
                            <tr [class.disabled-row]="!discount.enabled" *ngFor="let discount of Products; let i = index;">
                                <td>
                                    <input type="checkbox" [checked]="discount.enabled" (change)="toggleRow(discount,$event.target)">
                                </td>
                                <td><img style="width: 35px;" src="{{LogoURL}}"> </td>
                                <td>{{discount.defaultDisplayText}}</td>
                                <td>{{discount.maximum.sendValue}}</td>
                                <td>{{discount.commissionRate*100}}</td>
                                <td>
                                    <input [disabled]="!discount.enabled" type="text" value="{{AllDiscountValues}}" #discountValue (blur)="AddDiscountToArray(discountValue.value,discount)" #discountPercentage> &nbsp;&nbsp;&nbsp;
                                    <!-- <i style="color: rgb(19, 80, 222); font-size: 14px;" class="fa fa-save" (click)="addToArray(discount,discountPercentage.value)"></i> -->
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <!-- <table id="example2" class="table table-bordered table-hover">
                        <thead>
                            <tr>
                                <th>Logo</th>
                                <th>Name</th>
                                <th>Amount</th>
                                <th>Commission (In %)</th>
                                <th>Commisssion Reatiler</th>
                            </tr>
                        </thead>
                        <tbody *ngFor="let discount of Products; let i = index;">
                            <tr>
                                <td><img style="width: 35px;" src="{{LogoURL}}"> </td>
                                <td>{{discount.defaultDisplayText}}</td>
                                <td>{{discount.maximum.sendValue}}</td>
                                <td>{{discount.commissionRate*100}}</td>
                                <td>
                                    <input type="text" value="{{AllDiscountValues}}" #discountPercentage> &nbsp;&nbsp;&nbsp;
                                    <i style="color: rgb(19, 80, 222); font-size: 14px;" class="fa fa-save" (click)="onSubmit(discount,discountPercentage.value)"></i>
                                </td>
                            </tr>
                        </tbody>
                    </table> -->
                </div>
            </div>
            <!-- /.card-body -->
            <div class="card-footer">
                <button class="btn btn-primary"  (click)="SubmitAll(allDiscounts.value)">Save All</button>&nbsp;&nbsp;
                <!-- <button type="button" class="btn btn-primary" >Submit</button> &nbsp;&nbsp; -->
                <button type="button" class="btn btn-outline-dark" (click)="closeModal()">
                    Close
                </button>
            </div>
        </form>
    </div>


</div>